import appConfig from '@/config/global-config'
import fetcher from '@/services/fetcher'
import { buildQuery } from '@/utils/helpers'

const GET_CATEGORIES = `
query getCategories($filters: CategoryFilterInput) {
  categories(filters: $filters) {
    __typename
    items {
      image_banner
      children {
        breadcrumbs {
          ...BreadcrumbFields
        }
        ...CategoryTreeFields
        children {
          breadcrumbs {
            ...BreadcrumbFields
          }
          ...CategoryTreeFields
          children {
            breadcrumbs {
              ...BreadcrumbFields
            }
            ...CategoryTreeFields
          }
        }
      }
      ...CategoryTreeFields
    }
  }
}
fragment CategoryTreeFields on CategoryTree {
  include_in_menu
  level
  uid
  icon_image
  image
  product_count
  name
  url_key
  url_path
  include_in_menu
  children_count
  product_count
  position
  meta_title
  meta_keywords
  meta_description
}
fragment BreadcrumbFields on Breadcrumb {
  category_level
  category_name
  category_uid
  category_url_key
  category_url_path
}
`
export const getCategories = async (variables: { filters?: ICategoryFilterInput }, locale?: string) => {
  try {
    const response = await fetcher.get(buildQuery(GET_CATEGORIES, variables), {
      locale: locale || appConfig.defaultLocale,
    })
    if (response?.payload?.data?.categories) {
      return response.payload.data.categories?.items as ICategoryMenu[]
    }
    return null
  } catch (error) {
    console.error('Error fetching categories:', error)
    return null
  }
}
